import LayoutUtils from "./LayoutUtils";

/**
 * Used to determine if an element spans the entire given rectangle
 */
class BackgroundElementFilter {
  constructor(/** Object **/ backgroundRect) {
    this.backgroundRect = backgroundRect;
  }

  shouldFilter(/** Object **/ elementData) {
    let rel = LayoutUtils.getRectRelationship(elementData.rect, this.backgroundRect);
    return rel.contains || rel.overlap >= 0.9;
  }
}

export default BackgroundElementFilter;
